import { Button, Snackbar } from '@mui/material';
import React, { createContext, useCallback, useContext, useState } from 'react';

type GlobalErrorContextValue = {
  notifyChunkLoadFailure: () => void;
};

const GlobalErrorContext = createContext<GlobalErrorContextValue | undefined>(
  undefined,
);

export const useGlobalError = (): GlobalErrorContextValue => {
  const providerContext = useContext(GlobalErrorContext);
  return (
    providerContext || {
      notifyChunkLoadFailure: () => {},
    }
  );
};

interface GlobalErrorProviderProps {
  children: React.ReactNode;
}

export const GlobalErrorProvider: React.FC<GlobalErrorProviderProps> = ({
  children,
}) => {
  const [chunkErrorOpen, setChunkErrorOpen] = useState(false);

  const notifyChunkLoadFailure = useCallback(() => {
    setChunkErrorOpen(true);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const handleClose = () => {
    setChunkErrorOpen(false);
  };

  return (
    <GlobalErrorContext.Provider value={{ notifyChunkLoadFailure }}>
      {children}
      <Snackbar
        open={chunkErrorOpen}
        onClose={handleClose}
        autoHideDuration={null}
        message="Refresh Ledgible now to get the latest updates."
        action={
          <Button
            variant="contained"
            color="primaryDark"
            size="small"
            sx={{
              borderRadius: 28,
            }}
            onClick={handleReload}
          >
            Refresh
          </Button>
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </GlobalErrorContext.Provider>
  );
};
